import { lazyPreload } from 'stash/utils/lazy';

export const WelcomeToStash = lazyPreload(() =>
	import(
		'stash/components/screens/single-stock/WelcomeToStash' /* webpackChunkName: "WelcomeToStash" */
	)
);

export const LegalName = lazyPreload(() =>
	import(
		'stash/components/screens/legal-name/LegalName' /* webpackChunkName: "LegalName" */
	)
);

export const LegalNameAndCitizenshipAndDob = lazyPreload(() =>
	import(
		'stash/components/screens/legal-name/LegalNameAndCitizenshipAndDob' /* webpackChunkName: "LegalNameAndCitizenshipAndDob" */
	)
);

export const PhoneNumber = lazyPreload(() =>
	import(
		'stash/components/screens/phone-number/PhoneNumber' /* webpackChunkName: "PhoneNumber" */
	)
);

export const AddTrustedContact = lazyPreload(() =>
	import(
		'stash/components/screens/trusted-contact/AddTrustedContact' /* webpackChunkName: "AddTrustedContact" */
	)
);
export const PhoneNumberVerification = lazyPreload(() =>
	import(
		'stash/components/screens/phone-number-verification/PhoneNumberVerification' /* webpackChunkName: "PhoneNumberVerification" */
	)
);

export const TrustedContact = lazyPreload(() =>
	import(
		'stash/components/screens/trusted-contact/TrustedContact' /* webpackChunkName: "TrustedContact" */
	)
);

export const Country = lazyPreload(() =>
	import('stash/components/screens/country/Country' /* webpackChunkName: "Country" */)
);

export const Visa = lazyPreload(() =>
	import('stash/components/screens/visa/Visa' /* webpackChunkName: "Visa" */)
);

export const EmploymentStatus = lazyPreload(() =>
	import(
		'stash/components/screens/employment-status-combined/EmploymentStatus' /* webpackChunkName: "EmploymentStatus" */
	)
);

export const ConsolidatedQuestions = lazyPreload(() =>
	import(
		'stash/components/screens/consolidated-questions/ConsolidatedQuestions' /* webpackChunkName: "ConsolidatedQuestions"*/
	)
);

export const SocialSecurityNumber = lazyPreload(() =>
	import(
		'stash/components/screens/ssn/SocialSecurityNumber' /* webpackChunkName: "SocialSecurityNumber" */
	)
);

export const DuplicateSSNBlockScreen = lazyPreload(() =>
	import(
		'stash/components/screens/ssn/DuplicateSSNBlockScreen' /* webpackChunkName: "DuplicateSSNBlockScreen" */
	)
);

export const IdentityVerificationLoader = lazyPreload(() =>
	import(
		'stash/components/screens/identity-verification/IdentityVerificationLoader' /* webpackChunkName: "IdentityVerificationLoader" */
	)
);

export const IdentityVerificationError = lazyPreload(() =>
	import(
		'stash/components/screens/identity-verification/IdentityVerificationError' /* webpackChunkName: "IdentityVerificationError" */
	)
);

export const IdentityVerificationSuccess = lazyPreload(() =>
	import(
		'stash/components/screens/identity-verification/IdentityVerificationSuccess' /* webpackChunkName: "IdentityVerificationSuccess" */
	)
);

export const IdentityVerificationWaitingRoom = lazyPreload(() =>
	import(
		'stash/components/screens/identity-verification/IdentityVerificationWaitingRoom' /* webpackChunkName: "IdentityVerificationWaitingRoom" */
	)
);

export const Address = lazyPreload(() =>
	import('stash/components/screens/address/Address' /* webpackChunkName: "Address" */)
);

export const Affiliation = lazyPreload(() =>
	import(
		'stash/components/screens/affiliation/Affiliation' /* webpackChunkName: "Affiliation" */
	)
);

export const TierSelection = lazyPreload(() =>
	import(
		'stash/components/screens/tier-options-v2/TierSelection' /* webpackChunkName: "TierSelection" */
	)
);

export const SmartPortfolioContainer = lazyPreload(() =>
	import(
		'stash/components/screens/smart-portfolio-v2/SmartPortfolioContainer' /* webpackChunkName: "SmartPortfolioContainer" */
	)
);

export const AdvisoryESignature = lazyPreload(() =>
	import(
		'stash/components/screens/advisory-agreements/AdvisoryAgreements' /* webpackChunkName: "AdvisoryESignature" */
	)
);

export const AccountESignature = lazyPreload(() =>
	import(
		'stash/components/screens/account-esignature/AccountEsignature' /* webpackChunkName: "AccountEsignature" */
	)
);

export const LinkBankPrimer = lazyPreload(() =>
	import('stash/components/screens/link-bank-prop/LinkBankPrimer')
);

export const BankLinkContainer = lazyPreload(() =>
	import(
		'stash/components/screens/payment-source/BankLinkContainer' /* webpackChunkName: "BankLinkContainer" */
	)
);

export const AutoInvestSmartSummary = lazyPreload(
	() =>
		import(
			'stash/components/screens/set-schedule/AutoInvestSmartSummary'
		) /* webpackChunkName: "AutoInvestSmartSummary" */
);

export const AutoInvestSetSchedule = lazyPreload(
	() =>
		import(
			'stash/components/screens/set-schedule-container/AutoInvestSetScheduleContainer'
		) /* webpackChunkName: "AutoInvestSetSchedule" */
);

export const BillingSummary = lazyPreload(() =>
	import(
		'stash/components/screens/billing/BillingSummary' /* webpackChunkName: "BillingSummary" */
	)
);

export const OnboardingComplete = lazyPreload(() =>
	import(
		'stash/components/screens/onboarding-complete/OnboardingComplete' /* webpackChunkName: "OnboardingComplete" */
	)
);

export const SmartPortfolioTransitionScreen = lazyPreload(() =>
	import(
		'stash/components/screens/smart-portfolio/SmartPortfolioTransitionScreen' /* webpackChunkName: "SmartPortfolioTransitionScreen" */
	)
);

export const SmartPortfolioSuccess = lazyPreload(() =>
	import(
		'stash/components/screens/smart-portfolio/SmartPortfolioSuccess' /* webpackChunkName: "SmartPortfolioSuccess" */
	)
);

export const StateZeroHome = lazyPreload(() =>
	import(
		'stash/components/screens/state-zero-home/StateZeroHome' /* webpackChunkName: "StateZeroHome" */
	)
);

export const StateZeroPrimer = lazyPreload(() =>
	import(
		'stash/components/screens/state-zero-primer/StateZeroPrimer' /* webpackChunkName: "StateZeroPrimer" */
	)
);

export const InvestmentSelection = lazyPreload(() =>
	import(
		'stash/components/screens/investment-selection/InvestmentSelection' /* webpackChunkName: "InvestmentSelection" */
	)
);

export const InvestmentDetail = lazyPreload(() =>
	import(
		'stash/components/screens/investment-detail/InvestmentDetailContainer' /* webpackChunkName: "InvestmentDetailContainer" */
	)
);
